<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'orderplanning'"
    ></app-reporting-table>
  </p-card>

</ng-container>
